<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        input-debounce="1000"
        :options="options"
        @filter="filterFn"
        option-value="id"
        option-label="referencia"
        @filter-abort="abortFilterFn"
        :error="error"
        map-options
    >
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
                <q-item-section>
                    <q-item-label
                        >{{ scope.opt.id }}
                        {{ scope.opt.referencia }}</q-item-label
                    >
                    <q-item-label caption>{{
                        scope.opt.cliente?.A1_NOME
                    }}</q-item-label>
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref } from "vue";
import ObraService from "@/services/ObraService";

const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
    cliente: {
        type: [String, Number, Object],
        default: null,
    },
});
defineEmits(["update:modelValue"]);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const abortFilterFn = () => console.log("delayed filter aborted");

const filterFn = async (val, update, abort) => {
    if (!val) {
        abort();
        return [];
    }
    const { data } = await ObraService.list(val, props?.cliente);
    update(() => (options.value = data));
};
</script>
